import appCss from '../styles.css?inline';

let sheet: CSSStyleSheet | undefined;

/**
 * <a2ui-surface> renders into a shadow root, so the app's global stylesheet
 * does not reach our exercise components. Adopt it into that root.
 */
export function adoptAppStyles(root: ShadowRoot | null | undefined) {
  if (!root) return;
  if (!sheet) {
    sheet = new CSSStyleSheet();
    sheet.replaceSync(appCss);
  }
  if (!root.adoptedStyleSheets.includes(sheet)) {
    root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
  }
}
